export const renderIntegrations = (
  integrations:
    | { google_analytics_id?: string; facebook_pixel_id?: string }
    | undefined
) => {
  if (!integrations) return;

  // Facebook Pixel
  if (!isNaN(Number(integrations.facebook_pixel_id))) {
    if (!(window as any).fbq) {
      const script = document.createElement("script");
      script.text = `
        !function(f,b,e,v,n,t,s) {
          if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${integrations.facebook_pixel_id}');
          fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
    }
  }

  // Google Analytics
  if (integrations.google_analytics_id) {
    if (!(window as any).gtag) {
      const gaScript = document.createElement("script");
      gaScript.async = true;
      gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${integrations.google_analytics_id}`;
      document.head.appendChild(gaScript);

      (window as any).dataLayer = (window as any).dataLayer || [];
      function gtag(...args: any[]) {
        (window as any).dataLayer.push(args);
      }
      (window as any).gtag = gtag;

      gtag("js", new Date());
      gtag("config", integrations.google_analytics_id);
    }
  }
};
